import get from 'lodash/get';
import pick from 'lodash/pick';
import { createReducer } from '@reduxjs/toolkit';

import {
  ADMIN_CLEAR_TOKEN,
  ADMIN_REFRESH_TOKEN,
  ADMIN_SIGN_IN_WITH_TOKEN,
  ActionFailureType,
  ActionSuccessType,
} from 'constants/redux-actions';

const initState = {};

const adminAuthReducer = createReducer(initState, {
  [ActionSuccessType(ADMIN_SIGN_IN_WITH_TOKEN)]: (_, action) => get(action, 'payload.data', {}),
  [ActionSuccessType(ADMIN_REFRESH_TOKEN)]: (prevState, action) => ({
    ...prevState,
    ...pick(action.payload.data, ['token', 'expiresAt']),
  }),
  [ActionFailureType(ADMIN_REFRESH_TOKEN)]: () => initState,
  [ADMIN_CLEAR_TOKEN]: () => initState,
});

export default adminAuthReducer;
